import api from 'lib/trpcClient';
import { mapResponseToCapitalActionNoticeCreatorData } from './mapping';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

type Input = {
  capitalActionId: string;
  vehicleId: string;
};

export const useCapitalActionNotice = ({
  capitalActionId,
  vehicleId,
}: Input) => {
  const [data] = api.capitalActionNotice.get.useSuspenseQuery({
    capitalActionId,
    vehicleId,
  });

  const { mutate: save, ...saveMutation } =
    api.capitalActionNotice.update.useMutation(useHandleTrpcMutation()({}));

  const { mutate: publish, ...publishMutation } =
    api.capitalActionNotice.publish.useMutation(useHandleTrpcMutation()({}));

  return {
    data: mapResponseToCapitalActionNoticeCreatorData(data),
    saving: saveMutation.isPending || publishMutation.isPending,
    save,
    publish,
  };
};
